import { Extension } from '@tiptap/vue-2';

export const Formatting = Extension.create({
    name: 'formatting',
    addCommands() {
        return {
            clearFormatting: () => ({ chain }) =>
                chain()
                    .clearNodes()
                    .unsetAllMarks()
                    .run()
        }
    }
})
